module.exports = __webpack_public_path__ + "img/HZ-T4001.4b65b918.jpg";